export default __webpack_public_path__ + "static/media/snaptag_logo.f26e7457.svg";